/**
 * The Web Crypto API is an interface allowing a script to use cryptographic primitives
 * in order to build systems using cryptography.
 * more info: https://developer.mozilla.org/en-US/docs/Web/API/Web_Crypto_API
 *
 * https://webbjocke.com/javascript-web-encryption-and-hashing-with-the-crypto-api/
 *
 * https://gist.github.com/chrisveness/e5a07769d06ed02a2587df16742d3fdd
 *
 *
 * How to use
 *  generateHash('awesome-password-here').then(hash =>
        console.log(hash)
 *  );
 *
 *  hash512 = await generateHash('awesome-password-here');
 */

export default {
  // Returns if browser supports the crypto api
  supportsCrypto() {
    return window.crypto && crypto.subtle && window.TextEncoder;
  },

  // Hex function for ArrayBuffer
  hex(buff) {
    return [].map.call(new Uint8Array(buff), b => `00${b.toString(16)}`.slice(-2)).join("");
  },

  // Base64 encode
  encode64(buff) {
    console.log("el buff", buff);
    const result = btoa(new Uint8Array(buff).reduce((s, b) => s + String.fromCharCode(b), ""));
    return result;
  },

  // Base64 encode escaping the whole string
  utf8_to_b64(str) {
    return window.btoa(unescape(encodeURIComponent(str)));
  },

  // Base64 decode escaping the whole string
  b64_to_utf8(str) {
    return decodeURIComponent(escape(window.atob(str)));
  },

  // Hash function in javascript
  async generateHash(str) {
    if (this.supportsCrypto()) {
      const hashBuffer = await crypto.subtle.digest("SHA-512", new TextEncoder("utf-8").encode(str));
      const hashHex = this.hex(hashBuffer);
      const encodedHash = this.utf8_to_b64(hashHex);
      return encodedHash;
    } else {
      console.warn("Your browser does not supports the Web Crypto API");
    }
  },

  generateRandomKey() {
    return Math.random().toString(36).substring(2, 34) + Math.random().toString(36).substring(2, 34);
  }
};
